import { FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Add, Minus } from '@factorialco/f0-react/icons/app'

const ZOOM_IN = 1.2
const ZOOM_OUT = 0.8
const MIN_ZOOM = 25

interface Props {
  onClick: (scale: number) => void
  currentZoom: number
}

const ActionBar: FC<Props> = ({ onClick, currentZoom }) => {
  const handleZoomIn = () => {
    onClick(ZOOM_IN)
  }

  const handleZoomOut = () => {
    onClick(ZOOM_OUT)
  }

  return (
    <Box
      flexDirection="row"
      padding="s8"
      gap="s8"
      background="white"
      borderRadius={{ all: 'abs100' }}
      alignItems="center"
      boxShadow="s100"
    >
      <F0Button
        onClick={handleZoomOut}
        round
        variant="Ghost"
        size="md"
        hiddenLabel
        icon={Minus}
        disabled={currentZoom <= MIN_ZOOM}
      />
      <Text size="200" color="grey800" weight="semibold">
        {Math.round(currentZoom)}%
      </Text>
      <F0Button
        onClick={handleZoomIn}
        round
        variant="Ghost"
        size="md"
        hiddenLabel
        icon={Add}
        disabled={currentZoom >= 100}
      />
    </Box>
  )
}

export default ActionBar
